import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { requireFeatureFlag } from 'lib/routeGuards'

import Challenges from 'pages/Challenges'

const challengesSearchSchema = z.object({
  tab: z.enum(['list', 'map']).optional().default('list'),
  submitted: z.string().optional(),
  highlight: z.string().optional(),
})

const challengesSearchDefaults = { tab: 'list' } as const

export const Route = createFileRoute('/_auth/challenges/')({
  beforeLoad: requireFeatureFlag('challenges'),
  component: Challenges,
  validateSearch: zodValidator(challengesSearchSchema),
  search: {
    middlewares: [stripSearchParams(challengesSearchDefaults)],
  },
})
